<template>
  <div class="login">
      <el-row>
          <el-col :span="8">
              <el-input id="name"  v-model.trim="name" placeholder="请输入用户名">
                  <template slot="prepend">工&nbsp;&nbsp;&nbsp;&nbsp;号</template>
              </el-input>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="8">
              <el-input id="password" v-model.trim="password" type="password" placeholder="请输入密码">
                  <template slot="prepend">密&nbsp;&nbsp;&nbsp;&nbsp;码</template>
              </el-input>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="8">
              <el-button id="login" :loading="checkName" :disabled='checkSearch' v-on:click="check('login')" style="width:100%" type="primary">{{checkName ? '登&nbsp;&nbsp;录&nbsp;&nbsp;中' : '登&nbsp;&nbsp;录'}}</el-button>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="8">
              <el-button id="query" :loading="checkSearch" :disabled='checkName' v-on:click="check('search')" style="width:100%" type="success">{{checkSearch ? '查&nbsp;&nbsp;询&nbsp;&nbsp;中' : '查&nbsp;&nbsp;询'}}</el-button>
          </el-col>
      </el-row>
  </div>
</template>

<script>
import address from '@/libs/address'
import { decrypt, encrypt } from '@/libs/tools'
export default {
  name: "LoginPage",
  data() {
    return {
      name: '',
      password: '',
      loginRequest: address.loginUrl,
      checkName: false,
      checkSearch: false,
      // enableLoginDeptId: 478542,
      enableLoginDeptId: 504552   //生产环境
    }
  },
  methods: {
    setLoadingState(ofrom, ostate) {
      if (ofrom === 'login') {
        this.checkName = ostate;
      } else {
        this.checkSearch = ostate;
      }
    },
    resetLoginData() {
      this.name = '';
      this.password = '';
    },
    check(ofrom) {
      if(this.name.length == 0 || this.password.length == 0) {
          this.$message.error('用户名和密码都不能为空!');
      } else {
        this.setLoadingState(ofrom, true);
          const tempData = {
            user: this.name,
            pwd: this.password
          }
          this.$post(this.loginRequest,tempData).then(res => {
            console.log(res)
            if (!res.errorCode) {
              let dataA = JSON.parse(decrypt(res.data))
              if (dataA && dataA.userEntity && dataA.userEntity.organization && dataA.userEntity.organization.orgId){
                if (dataA.userEntity.organization.orgId == this.enableLoginDeptId) {
                  console.log(dataA.userEntity.organization.orgId);
                  console.log(this.enableLoginDeptId);
                  this.$store.commit('changeLoginState', true);
                  this.$router.push({
                    path: ofrom == 'login' ? '/main' : '/search'
                    ,query: {
                      userId: this.name,
                      casCookie:dataA.casCookie,
                      sessionId:dataA.sessionId
                  }});
                } else {
                  this.$message.error('对不起，您没有权限！');
                }
              } else {
                this.$message.error('数据错误！');
              }
            } else {
              this.$message.error('用户名或密码错误!');
            }
            this.setLoadingState(ofrom, false);
          })
          .catch(() => {
            this.$message.error('网络错误, 请检查网络!');
            this.setLoadingState(ofrom, false);
          })
      }
    }
  },
  mounted() {
  }
};
</script>

<style lang='scss' scoped>
.login {
    margin-top: 4%;
    margin-left: 40%;
    .el-row {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0px;
        }
        .el-button--primary {
          background: #003c8d;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue